module.exports = __webpack_public_path__ + "static/media/shortA1ShortA2Test.ebb74566.mp3";